const es = {
  // ── Navigation ─────────────────────────────
  nav: {
    dashboard: 'Panel',
    workOrders: 'Ordenes',
    customers: 'Clientes',
    calendar: 'Calendario',
    invoices: 'Facturas',
    estimates: 'Presupuestos',
    inventory: 'Inventario',
    team: 'Equipo',
    reports: 'Informes',
    settings: 'Ajustes',
    myWork: 'Mi trabajo',
    contracts: 'Contratos',
    tracking: 'Seguimiento',
    csat: 'CSAT',
    leaderboard: 'Ranking',
    bookings: 'Reservas',
    dispatch: 'Despacho',
    more: 'Mas',
  },

  // ── Common actions ─────────────────────────
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    back: 'Volver',
    close: 'Cerrar',
    confirm: 'Confirmar',
    loading: 'Cargando...',
    saving: 'Guardando...',
    noResults: 'Sin resultados',
    required: 'Obligatorio',
    optional: 'Opcional',
    all: 'Todos',
    active: 'Activo',
    inactive: 'Inactivo',
    yes: 'Si',
    no: 'No',
    or: 'o',
    of: 'de',
    showing: 'Mostrando',
    rows: 'filas',
    page: 'Pagina',
    previous: 'Anterior',
    next: 'Siguiente',
  },

  // ── Page titles ────────────────────────────
  pages: {
    dashboard: {
      title: 'Panel de control',
      subtitle: 'Resumen de tu empresa',
    },
    workOrders: {
      title: 'Ordenes de trabajo',
      subtitle: 'Gestiona las ordenes de servicio',
      new: 'Nueva orden',
      detail: 'Detalle de orden',
    },
    customers: {
      title: 'Clientes',
      subtitle: 'Gestiona tus clientes',
      new: 'Nuevo cliente',
      detail: 'Detalle de cliente',
    },
    calendar: {
      title: 'Calendario',
      subtitle: 'Vista de planificacion',
    },
    invoices: {
      title: 'Facturas',
      subtitle: 'Facturacion y cobros',
      new: 'Nueva factura',
    },
    estimates: {
      title: 'Presupuestos',
      subtitle: 'Gestiona tus presupuestos',
      new: 'Nuevo presupuesto',
    },
    inventory: {
      title: 'Inventario',
      subtitle: 'Control de materiales y stock',
    },
    team: {
      title: 'Equipo',
      subtitle: 'Gestiona tu equipo de trabajo',
      invite: 'Invitar miembro',
    },
    reports: {
      title: 'Informes',
      subtitle: 'Metricas y analisis',
    },
    settings: {
      title: 'Ajustes',
      subtitle: 'Configura tu cuenta y organizacion',
    },
  },

  // ── Auth ────────────────────────────────────
  auth: {
    login: 'Iniciar sesion',
    register: 'Crear cuenta',
    logout: 'Cerrar sesion',
    email: 'Email',
    password: 'Contrasena',
    confirmPassword: 'Confirmar contrasena',
    forgotPassword: 'Has olvidado tu contrasena?',
    resetPassword: 'Restablecer contrasena',
    sendResetLink: 'Enviar enlace',
    newPassword: 'Nueva contrasena',
    name: 'Nombre',
    companyName: 'Nombre de la empresa',
    loginTitle: 'Bienvenido de nuevo',
    loginSubtitle: 'Inicia sesion en tu cuenta de WorSaaS',
    registerTitle: 'Crea tu cuenta',
    registerSubtitle: 'Empieza a gestionar tu empresa',
    forgotTitle: 'Recuperar contrasena',
    forgotSubtitle: 'Te enviaremos un enlace para restablecer tu contrasena',
    resetTitle: 'Nueva contrasena',
    resetSubtitle: 'Introduce tu nueva contrasena',
    continueWithGoogle: 'Continuar con Google',
    noAccount: 'No tienes cuenta?',
    hasAccount: 'Ya tienes cuenta?',
    passwordMinLength: 'Minimo 8 caracteres',
    invalidCredentials: 'Email o contrasena incorrectos',
    emailSent: 'Email enviado. Revisa tu bandeja de entrada.',
    passwordChanged: 'Contrasena actualizada correctamente',
  },

  // ── Work Orders ────────────────────────────
  workOrder: {
    status: {
      pending: 'Pendiente',
      scheduled: 'Programada',
      in_progress: 'En curso',
      completed: 'Completada',
      cancelled: 'Cancelada',
      on_hold: 'En espera',
    },
    priority: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
    },
    fields: {
      title: 'Titulo',
      description: 'Descripcion',
      customer: 'Cliente',
      assignedTo: 'Asignado a',
      service: 'Servicio',
      scheduledDate: 'Fecha programada',
      scheduledTime: 'Hora',
      priority: 'Prioridad',
      status: 'Estado',
      address: 'Direccion',
      notes: 'Notas internas',
    },
  },

  // ── Invoices ───────────────────────────────
  invoice: {
    status: {
      draft: 'Borrador',
      sent: 'Enviada',
      paid: 'Pagada',
      overdue: 'Vencida',
      cancelled: 'Cancelada',
    },
    fields: {
      number: 'Numero',
      customer: 'Cliente',
      issueDate: 'Fecha emision',
      dueDate: 'Fecha vencimiento',
      subtotal: 'Subtotal',
      tax: 'IVA',
      total: 'Total',
    },
  },

  // ── Settings tabs ──────────────────────────
  settings: {
    tabs: {
      general: 'General',
      services: 'Servicios',
      checklists: 'Checklists',
      notifications: 'Notificaciones',
      automations: 'Automatizaciones',
      customFields: 'Campos',
      integrations: 'Integraciones',
      billing: 'Facturacion',
    },
    language: {
      title: 'Idioma',
      subtitle: 'Selecciona el idioma de la interfaz',
    },
  },

  // ── Toasts / feedback ─────────────────────
  toast: {
    saved: 'Guardado correctamente',
    deleted: 'Eliminado correctamente',
    created: 'Creado correctamente',
    updated: 'Actualizado correctamente',
    error: 'Ha ocurrido un error',
    errorSaving: 'Error al guardar',
    errorDeleting: 'Error al eliminar',
    errorLoading: 'Error al cargar los datos',
    copied: 'Copiado al portapapeles',
  },

  // ── Empty states ──────────────────────────
  empty: {
    workOrders: 'No hay ordenes de trabajo',
    customers: 'No hay clientes',
    invoices: 'No hay facturas',
    estimates: 'No hay presupuestos',
    inventory: 'No hay items en inventario',
    team: 'No hay miembros en el equipo',
  },
} as const;

export default es;
